const CORE_PLANS = ['light-plan', 'starter-plan', 'pro-plan', 'all-access-plan'];
const FALLBACK = '/account-settings/subscriptions';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8082';
const TOKEN_KEY = 'annualOfferPurchaseToken';

function safeContinuation(value: string): string {
  if (!value.startsWith('/') || value.startsWith('//')) return FALLBACK;
  try {
    const origin = window.location.origin;
    const target = new URL(value, origin);
    if (target.origin !== origin || target.pathname.startsWith('/checkout/annual-offer'))
      return FALLBACK;
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return FALLBACK;
  }
}
export function buildAnnualOfferPath(destination: string, productSlugs: string[]): string {
  if (!productSlugs.some((slug) => CORE_PLANS.includes(slug))) return destination;
  return `/checkout/annual-offer?${new URLSearchParams({ continue: safeContinuation(destination) })}`;
}
export function annualOfferContinuePath(search: string): string {
  return safeContinuation(new URLSearchParams(search).get('continue') || FALLBACK);
}
export function rememberAnnualOfferPurchaseToken(response: { annualOfferToken?: string }): void {
  if (response.annualOfferToken)
    window.sessionStorage.setItem(TOKEN_KEY, response.annualOfferToken);
}
export async function annualOfferRequest(
  action: '' | 'accept' | 'decline' = '',
  offerId?: string,
  apiToken?: string | null,
) {
  const token = apiToken || window.localStorage.getItem('customAuthToken');
  const purchaseToken = window.sessionStorage.getItem(TOKEN_KEY);
  const headers = new Headers({ 'Content-Type': 'application/json' });
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (purchaseToken) headers.set('X-Annual-Offer-Token', purchaseToken);
  const response = await fetch(
    `${API_URL}/subscription-management/annual-offer${action ? `/${action}` : ''}`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(offerId ? { offerId } : {}),
    },
  );
  const data = await response.json();
  if (!response.ok)
    throw Object.assign(new Error(data.message || 'Your offer could not be verified.'), {
      code: data.code,
      status: response.status,
    });
  return data;
}
